export type ColorScheme =
  | "goldenHour"
  | "hazySundown"
  | "fierceSundown"
  | "sunrise"
  | "midMorning"
  | "afterNoon";

export const moduleNameToSchemaMap = new Map([
  ["Empowered Eating", "goldenHour"],
  ["Lifestyle and Ongoing Care", "goldenHour"],
  ["The Mindset Shift", "hazySundown"],
  ["Focus on Nutrition", "afterNoon"],
  ["Movement for Life", "fierceSundown"],
  ["Long-Term Success", "afterNoon"],
  ["The Foundations", "sunrise"],
  ["Building Healthy Habits", "midMorning"],
  ["Treatment Options", "midMorning"]
]);
